export const checkEmailValid = (str) => {
  const isValidEmail = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g;
  return str.match(isValidEmail);
};

export const checkPhoneValid = (str) => {
  const isValidPhone = /^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\./0-9]*$/;
  return isValidPhone.test(str);
};

export const checkStringIsNumeric = (str) => {
  return !isNaN(parseFloat(str)) && isFinite(str);
};

export const checkNonEmptyValues = (obj) => {
  return Object.values(obj).every(Boolean);
};
